<div class="width-lg max-width-lg">
    <div>
        <strong>{{ area?.code }}</strong>
        <span class="float-right">
            <nz-tag [nzColor]="area?.type != null ? typeColor[area.type] : ''">
                {{ area?.type != null ? typeLabel[area.type] : '' }}
            </nz-tag>
        </span>
    </div>
    <div nz-tooltip="{{ area?.name }}" [nzTooltipPlacement]="'top'">
        <small>{{ area?.name }}</small>
    </div>
    <div class="area-status" *ngIf="area?.isDefault">
        <nz-tag nzColor="gold">Default</nz-tag>
    </div>
    <nz-divider class="m-none"></nz-divider>
</div>